import React from 'react';
import { StyleSheet } from 'react-native';
import {
  BodyText,
  ListActionPressable,
  usePressableState,
} from '@sweetgreen/garnish';

import { useLocalizationContext } from '@order/Localization';

import type { DeliveryPreferenceType } from '../../graphql/types';
import { usePreferencesText } from './hooks';

export const DeliveryPreferencesItem = ({
  preferences,
  onPress,
}: DeliveryPreferencesItemProps) => {
  const { t } = useLocalizationContext();
  const preferencesText = usePreferencesText(preferences.type);
  const pressableRef = React.useRef(null);
  const { isActive, isFocused, isHovered } = usePressableState(pressableRef);
  const active = isActive || isFocused || isHovered;

  return (
    <ListActionPressable
      testID="delivery.preferences.trigger"
      ref={pressableRef}
      accessibilityRole="button"
      accessibilityLabel={t('delivery.preferences.title')}
      accessibilityHint={t('delivery.preferences.title')}
      onPress={onPress}
      iconName="IconBagStroke"
    >
      <BodyText size={4} bold style={[styles.title, active && styles.active]}>
        {preferencesText}
      </BodyText>
      <BodyText size={4} lineBreakMode="head">
        {/* eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing -- @REVIEW */}
        {preferences.notes || t('delivery.preferences.note-hint')}
      </BodyText>
    </ListActionPressable>
  );
};

type DeliveryPreferences = {
  readonly type: DeliveryPreferenceType;
  readonly notes?: string;
};

type DeliveryPreferencesItemProps = {
  readonly preferences: DeliveryPreferences;
  readonly onPress: () => void;
};

const styles = StyleSheet.create({
  title: {
    textTransform: 'capitalize',
  },
  active: {
    textDecorationLine: 'underline',
  },
});
